import type { CSSProperties } from "react"
import type { Cell } from "@tanstack/react-table"
import { useSortable } from "@dnd-kit/sortable"
import { CSS } from "@dnd-kit/utilities"
import { flexRender } from "@tanstack/react-table"
import { TableCell } from "@components/ui/table"
import { cn } from "@components/ui/lib/utils"

interface DragAlongCellProps<TData, TValue> {
  cell: Cell<TData, TValue>
  cellPadding: string
  enableColumnResizing: boolean
}

export const DragAlongCell = <TData, TValue>({
  cell,
  cellPadding,
  enableColumnResizing,
}: DragAlongCellProps<TData, TValue>) => {
  const { isDragging, setNodeRef, transform } = useSortable({
    id: cell.column.id,
  })

  const style: CSSProperties = {
    opacity: isDragging ? 0.8 : 1,
    position: "relative" as const,
    transform: CSS.Translate.toString(transform),
    transition: "width transform 0.2s ease-in-out",
    width: enableColumnResizing ? cell.column.getSize() : undefined,
    zIndex: isDragging ? 1 : 0,
  }

  return (
    <TableCell
      ref={setNodeRef}
      style={style}
      className={cn("tw:break-words tw:whitespace-normal", cellPadding)}
    >
      {flexRender(cell.column.columnDef.cell, cell.getContext())}
    </TableCell>
  )
}
